export const pipelineStages = [
  { value: "new", label: "New" },
  { value: "reviewing", label: "Review" },
  { value: "qualified", label: "Qualified" },
  { value: "follow_up", label: "Follow-up" },
  { value: "closed", label: "Closed" },
];

export function getLeadName(lead) {
  return `${lead.first_name || ""} ${lead.last_name || ""}`.trim() || lead.email;
}